import React, { Component } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import 'react-table/react-table.css';

import { RenderIfToggleOn, RenderIfToggleOff } from 'components/shared/ToggleRenderer';
import { featureEnabled } from 'helpers/ToggleBot';
import { default as AntDrawer } from 'components/ui/Drawer';

import CreateEditPromotion from './OldPromotionForm/CreateEditPromotion';
import CreatePromotion from './CreatePromotion';
import EditPromotion from './EditPromotion';
import PromotionsTable from './PromotionTable/PromotionsTable';
import PromotionsMobile from './PromotionTable/PromotionsMobile';

import { getPromotions } from 'actions/landlordPropertiesActions';
import { getPromotion } from './store/actions';

class LandlordPromotions extends Component {
  state = {
    createEditDialogOpen: false,
    createPromotionDrawerOpen: false,
    viewPromotionDrawerOpen: false,
    promotionDetails: null,
  };

  componentDidMount() {
    this.props.getPromotions();
  }

  toggleCreatePromotion = () => {
    this.setState({
      createEditDialogOpen: !this.state.createEditDialogOpen,
      createPromotionOpen: !this.state.createPromotionOpen,
      viewPromotionDrawerOpen: false,
      promotionDetails: null,
    });
  };

  toggleViewPromotion = async promotionDetails => {
    if (featureEnabled('property_multiselect')) {
      await this.props.getPromotion(promotionDetails.id);
    }
    this.setState({
      createEditDialogOpen: !this.state.createEditDialogOpen,
      createPromotionOpen: false,
      viewPromotionDrawerOpen: !this.state.viewPromotionDrawerOpen,
      promotionDetails: promotionDetails,
    });
  };

  closeViewPromotion = () => {
    this.setState({
      createEditDialogOpen: false,
      createPromotionOpen: false,
      viewPromotionDrawerOpen: false,
    });
  };

  render() {
    const promotions = this.props.promotions || [];

    return (
      <div className="body" role="main">
        <div className="centers">
          <RenderIfToggleOff toggle="property_multiselect">
            <CreateEditPromotion
              togglePromotionDialog={this.toggleCreatePromotion}
              promotionIsOpen={this.state.createEditDialogOpen}
              promotionDetails={this.state.promotionDetails}
            />
          </RenderIfToggleOff>
          <RenderIfToggleOn toggle="property_multiselect">
            <AntDrawer
              maskClosable={false}
              keyboard
              visible={this.state.createPromotionOpen}
              onClose={this.toggleCreatePromotion}
              closable={false}
              width={600}
            >
              {this.state.createPromotionOpen && (
                <CreatePromotion
                  handleClose={this.closeViewPromotion}
                  onSubmissionComplete={() => this.props.getPromotions()}
                />
              )}
            </AntDrawer>
            <AntDrawer
              maskClosable={false}
              keyboard
              visible={this.state.viewPromotionDrawerOpen}
              onClose={this.toggleViewPromotion}
              closable={false}
              width={600}
            >
              {this.state.viewPromotionDrawerOpen && (
                <EditPromotion
                  handleClose={this.closeViewPromotion}
                  onSubmissionComplete={() => this.props.getPromotions()}
                />
              )}
            </AntDrawer>
          </RenderIfToggleOn>
          <MediaQuery query="(min-device-width: 650px)">
            <PromotionsTable
              togglePromotionDialog={this.toggleCreatePromotion}
              promotions={promotions}
              optionsDropdown={this.state.createEditDialogOpen}
              togglePromotionDetailsDialog={this.toggleViewPromotion}
            />
          </MediaQuery>

          <MediaQuery query="(max-device-width: 650px)">
            <PromotionsMobile
              togglePromotionDialog={this.toggleCreatePromotion}
              promotions={promotions}
              optionsDropdown={this.state.createEditDialogOpen}
              togglePromotionDetailsDialog={this.toggleViewPromotion}
            />
          </MediaQuery>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  promotions: store.landlordProperties.promotions,
});

const mapDispatchToProps = {
  getPromotions,
  getPromotion,
};

export default connect(mapStateToProps, mapDispatchToProps)(LandlordPromotions);
